/**
 * Renders one full-tree left navigation parent row and its optional child items.
 * Owns presentation and emits parent/child interaction events to the container.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LeftNavItem, LeftNavSubItem } from '../../models/left-nav-item.model';

@Component({
    selector: 'sb-left-nav-tree-item',
    templateUrl: './left-nav-tree-item.component.html',
    styleUrls: ['./left-nav-tree-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeftNavTreeItemComponent {
    @Input({ required: true }) item!: LeftNavItem;
    @Input() iconPath = '';
    @Input() isExpanded = false;
    @Input() activeModuleId: string | null = null;
    @Input() activeItemId: string | null = null;

    @Output() parentToggled = new EventEmitter<string>();
    @Output() parentSelected = new EventEmitter<string>();
    @Output() childSelected = new EventEmitter<{ moduleId: string; childId: string }>();

    get hasChildren(): boolean {
        return !!this.item.children?.length;
    }

    get isParentActive(): boolean {
        return this.activeModuleId === this.item.id && !this.hasActiveChild;
    }

    get hasActiveChild(): boolean {
        return !!this.item.children?.some((child) => child.id === this.activeItemId);
    }

    onParentSelect(): void {
        this.parentSelected.emit(this.item.id);
    }

    onToggle(event: MouseEvent): void {
        event.stopPropagation();
        this.parentToggled.emit(this.item.id);
    }

    onChildSelect(child: LeftNavSubItem): void {
        this.childSelected.emit({ moduleId: this.item.id, childId: child.id });
    }
}
